import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

let abortControllerFetchDuluxPalete = null;

/**
 * Gọi API lấy bảng màu dulux
 */
export const fetchDuluxPaletes = createAsyncThunk(
  'get/windmill/dulux',
  async (_, { dispatch }) => {
    try {
      if (abortControllerFetchDuluxPalete) {
        abortControllerFetchDuluxPalete.abort();
      }
      abortControllerFetchDuluxPalete = new AbortController();

      const res = await axios({
        method: 'GET',
        url: process.env.REACT_APP_URL_DULUX_PALETE,
        signal: abortControllerFetchDuluxPalete.signal,
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);
